import { Tag, TagProps } from 'antd';
import classNames from 'classnames';
import { CloseCircle } from 'iconsax-react';

type chipProps = {
  children: React.ReactNode;
  type: 'success' | 'error' | 'warning' | 'primary' | 'default';
  className?: string;
};

const chipStyles = {
  success: {
    text: 'text-light-success dark:text-dark-success',
    bg: 'bg-green-50 dark:bg-green-950/40',
    color: '#4DA167',
  },
  error: {
    text: 'text-light-warning dark:text-dark-warning',
    bg: 'bg-[#F7E7E8]',
    color: '#CC2936',
  },
  warning: {
    text: 'text-light-alert dark:text-dark-alert',
    bg: 'bg-yellow-50 dark:bg-yellow-950/40',
    color: '#F58F29',
  },
  primary: {
    text: 'text-light-information dark:text-dark-information',
    bg: 'bg-blue-50 dark:bg-blue-950/40',
    color: '#3C91E6',
  },
  default: {
    text: 'text-light-text-primary dark:text-dark-text-primary',
    bg: 'bg-[#F3F6FD]',
    color: '#000000',
  },
};

import { twMerge } from 'tailwind-merge';

export default function Chip({
  children,
  type = 'success',
  bordered = false,
  className,
  ...rest
}: chipProps & TagProps) {
  return (
    <Tag
      className={twMerge(classNames(
        `${chipStyles[type].text} ${chipStyles[type].bg} font-normal !rounded-lg capitalize border-none px-3 py-1`,
        className
      ))}
      bordered={bordered}
      {...(rest?.closable && {
        closeIcon: (
          <CloseCircle
            color={chipStyles[type].color}
            size={16}
            className="inline-block"
          />
        ),
        onClose: (e) => {
          e.preventDefault();
          rest.onClose?.(e);
        },
      })}
      {...rest}
    >
      {children}
    </Tag>
  );
}
